"use client";

import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ImageGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const images = [{
    id: 1,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/professional_accountant_portrait.png",
    alt: "Professional accountant in modern office setting"
  }, {
    id: 2,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/financial_documents_calculator.png",
    alt: "Financial documents and calculator on desk"
  }, {
    id: 3,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/modern_office_architecture.png",
    alt: "Bright modern office architecture with natural light"
  }, {
    id: 4,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/business_handshake_meeting.png",
    alt: "Business professionals in consultation meeting"
  }];
  return <section id="image-grid" ref={ref} className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-0 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {images.map((image, i) => <div key={image.id} data-index={i} className="group relative overflow-hidden">
              <AspectRatio ratio={4 / 3}>
                <img src={image.src} alt={image.alt} className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.02]" />
              </AspectRatio>
            </div>)}
        </div>
      </div>
    </section>;
}